import React from 'react';
import ReactDOM from 'react-dom'
import {connect} from 'react-redux'
import {hydrate} from 'react-dom'
import PropTypes from 'prop-types';

import externalService from './external-service';

import Loading from '../../loading/loading'

import './external.styl'
class External extends React.Component {
    static propTypes = {
        url: PropTypes.string,
    }

    static contextTypes = {
        store: PropTypes.object.isRequired
    }

    state = {
        html: false
    }

    UNSAFE_componentWillMount() {
        this.state.locale = this.context.store.app.locale
    }

    componentDidMount () {
        this.get(this.state.locale)
    }

    componentDidUpdate() {
        if(!this.state.html) return
        const data = <div dangerouslySetInnerHTML={{__html: this.state.html}}></div>
        this.state.html && ReactDOM.render(data, this.refs.external)
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if(nextProps.locale !== this.state.locale) {
            this.get(nextProps.locale)
        }
    }

    get(locale) {
        this.setState({html: false})
        externalService.content(this.props.url, {locale}).then(html => this.setState({locale, html}))
    }

    render() {
        const {html} = this.state
        if(!html) return <Loading printable={true} />
        return <div ref="external"></div>
    }
}

const mapStateToProps = state => {
    const {locale} = state.langReducers
    return {locale}
}
export default connect(mapStateToProps)(External)
